import { styled } from 'styled-components';

import { Image } from 'src/components/image';
import { colorNeutral, colorNeutral900 } from 'src/styles/colors';
import { focus } from 'src/styles/mixins';

export const StyledImage = styled(Image)`
  filter: brightness(0.75) contrast(0.5);
  height: auto;
  transition: filter 280ms;
`;

export const StyledVideoThumbnail = styled.button`
  border-width: 0;
  padding: 0;
  max-width: 121px;
  position: relative;
  cursor: pointer;

  &::before,
  &::after {
    transition: 280ms;
    opacity: 0.5;
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
  }

  &::before {
    background-color: ${colorNeutral900};
    border-radius: 40%/30%;
    padding: 13px 18px;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  &::after {
    border-color: transparent;
    border-style: solid;
    border-width: 7px;
    border-left-color: ${colorNeutral};
    border-left-width: 10px;
    border-right-width: 0;
    transform: translate(-40%, -50%);
    z-index: 2;
  }

  &:hover,
  &:focus {
    ${StyledImage} {
      filter: none;
    }

    &::before,
    &::after {
      opacity: 1;
    }
  }

  ${focus}
`;

export const StyledOverlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 3;
  background-color: rgb(0 0 0 / 30%);
  top: 0;
  left: 0;
`;
